export interface ApprovalPost {
  action: ApprovalPostAction;
}

export enum ApprovalPostAction {
  approve = 'approve',
  reject = 'reject',
}
